import React from "react";
import {useNavigate} from "react-router-dom";
import {Card, Col, Row, Spin} from "antd";
import dayjs from "dayjs";

import {getDistanceUnit} from "../../helpers/booking";
import {messageType, showMessages} from "../../helpers/message";
import {dateTimeFormat} from "../../lib/time";
import {useGetJourneyQuery} from "../../store/api/bookingsApi";
import {JourneyDetailsCardParams} from "../../types/bookingTypes";
import {BaseError} from "../../types/apiTypes";

const JourneyDetailsCard = ({journeyID}: JourneyDetailsCardParams) => {
    const navigate = useNavigate();
    const {data: journey, isFetching: journeyLoading, isError: isJourneyError, error: journeyError} = useGetJourneyQuery(journeyID);

    React.useEffect(() => {
        if (isJourneyError) {
            showMessages((journeyError as BaseError).data?.message, messageType.error);
            if (!journey) navigate('/404');
        }
    }, [journey, journeyError, isJourneyError, navigate]);

    return (
        <Card title="What You're Billed" className="booking-manage-details-card">
            <Spin spinning={journeyLoading}>
                <Row>
                    <Col md={10} xs={12}><strong>Start Time:</strong></Col>
                    <Col md={14} xs={12}>{journey?.billing_started_at ? dayjs(journey.billing_started_at).tz().format(dateTimeFormat) : 'N/A'}</Col>
                </Row>
                <Row>
                    <Col md={10} xs={12}><strong>End Time:</strong></Col>
                    <Col md={14} xs={12}>{journey?.billing_ended_at ? dayjs(journey.billing_ended_at).tz().format(dateTimeFormat) : 'N/A'}</Col>
                </Row>
                <Row>
                    <Col md={10} xs={12}><strong>Distance:</strong></Col>
                    <Col md={14} xs={12}>{journey?.distance + ' ' + getDistanceUnit()}</Col>
                </Row>
            </Spin>
        </Card>
    );
}

export default JourneyDetailsCard;
